import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const Contact = () => {
  const initialState = {
    name: "",
    email: "",
    address: "",
    phone: "",
    message: "",
  };
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log(formData);
  };
  const handleReset = () => {
    setFormData(initialState);
  };
  return (
    <>
      <Row>
        <Col md={6}>
          <Container className="p-5 mx-md-5">
            <Row className="mt-4">
              <h2>Interested in Discussing</h2>
              <Container className="mt-2">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={5}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={5}>
                      <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label>Address *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="phone"
                          placeholder="Enter Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={10}>
                      <Form.Group className="mb-3" controlId="formMessage">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter Message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button type="button" className="btn btn-primary" size="lg">
                    Send Your Message
                  </Button>
                  <Button
                    size="lg"
                    type="button"
                    className="btn btn-secondary ms-3"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Form>
              </Container>
            </Row>
          </Container>
        </Col>

        <Col md={4} className="p-5 mx-md-5">
          <div class="card text-center p-4 bg-dark">
            <div class="card-body bg-black">
              <h5 class="card-title text-light">OUR OFFICE LOCATION</h5>
              <p class="card-text text-light">
                Bar Association Dehardun, Court Compound Near SSP Office, Court
                Road Dehardun, Uttarakhand
              </p>
            </div>
          </div>

          <div class="card text-center mt-md-4 p-4 bg-dark">
            <div class="card-body">
              <h5 class="card-title text-light">OUR CONTACT NUMBER</h5>
              <p class="card-text text-light">07533881186</p>
            </div>
          </div>

          <div class="card text-center mt-md-4 p-4 bg-dark">
            <div class="card-body">
              <h5 class="card-title text-light">OUR CONTACT E-MAIL</h5>
              <p class="card-text text-light">barassociationd.dun@gmail.com</p>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Contact;
